import type { ViewStyle } from "react-native";
import { X } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { EmptyState } from "./EmptyState";
import { CompactActionButton } from "./CompactActionButton";

/** Compact, recoverable absence within a search or filtered list. */
export function SearchEmptyState({
  title,
  subtitle,
  onReset,
  style,
}: {
  title: string;
  subtitle?: string;
  onReset?: () => void;
  style?: ViewStyle;
}) {
  const t = useTranslations();
  return (
    <EmptyState
      density="compact"
      title={title}
      subtitle={subtitle ?? t("empty_states.try_another_search_or_filters")}
      action={
        onReset ? (
          <CompactActionButton
            label={t("empty_states.clear_search_and_filters")}
            action="empty_states.clear_search_and_filters"
            variant="secondary"
            leadingIcon={X}
            onPress={onReset}
          />
        ) : undefined
      }
      style={{ paddingVertical: 28, ...style }}
    />
  );
}
